import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const BookShop = () => {
  useEffect(() => {
    document.title = "Book Shop -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Other Facilities</li>
          <li>Book Shop</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Book Shop </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                The prescribed set of books for the academic session 2010-2011
                will be available in the school Book Shop.Other stationery items
                such as notebooks, files folders, maps are also available.
                Students must buy the stationery from the shop, as it bears the
                school name. This is mandatory because it ensures uniformity.
                Students will not be allowed to leave their classes to make
                purchases. Parents are requested to buy books for their wards to
                ensure that the students do not miss their classes.
              </p>
            </div>
            <div className="col-lg-12">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/BookShop.jpg"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/BookShop.jpg"
                    className="mx-auto d-block schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookShop;
